import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
type UseScrollNavigationOptions = {
  itemCount: number;
  isMobile: boolean;
};
export function useScrollNavigation(t0) {
  const $ = _c(17);
  const {
    itemCount,
    isMobile
  } = t0;
  const scrollAreaRef = useRef(null);
  const viewportRef = useRef(null);
  const firstCardRef = useRef(null);
  const [canScrollUp, setCanScrollUp] = useState(false);
  const [canScrollDown, setCanScrollDown] = useState(false);
  const [cardHeight, setCardHeight] = useState(0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (!scrollAreaRef.current) {
        return;
      }
      const scrollAreaRoot = scrollAreaRef.current.querySelector("[data-slot=\"scroll-area\"]") as HTMLElement | null;
      if (!scrollAreaRoot) {
        return;
      }
      const viewport = scrollAreaRoot.querySelector("[data-slot=\"scroll-area-viewport\"]") as HTMLElement | null;
      if (!viewport) {
        return;
      }
      viewportRef.current = viewport;
      const handleScroll = () => {
        const {
          scrollTop,
          scrollHeight,
          clientHeight
        } = viewport;
        const isAtTop = scrollTop <= 0;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;
        const canScroll = scrollHeight > clientHeight;
        setCanScrollUp(!isAtTop && canScroll);
        setCanScrollDown(!isAtBottom && canScroll);
      };
      viewport.addEventListener("scroll", handleScroll);
      const timeoutId = setTimeout(handleScroll, 100);
      return () => {
        viewport.removeEventListener("scroll", handleScroll);
        clearTimeout(timeoutId);
      };
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== itemCount) {
    t2 = [itemCount];
    $[1] = itemCount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      if (!firstCardRef.current) {
        return;
      }
      const measureCard = () => {
        const cardElement = firstCardRef.current;
        if (!cardElement) {
          return;
        }
        const measuredHeight = cardElement.offsetHeight;
        setCardHeight(measuredHeight + 40);
      };
      const rafId = requestAnimationFrame(() => {
        measureCard();
      });
      return () => {
        cancelAnimationFrame(rafId);
      };
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isMobile || $[5] !== itemCount) {
    t4 = [itemCount, isMobile];
    $[4] = isMobile;
    $[5] = itemCount;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== cardHeight) {
    t5 = () => {
      const viewport_0 = viewportRef.current;
      if (!viewport_0 || cardHeight === 0) {
        return;
      }
      viewport_0.scrollBy({
        top: cardHeight,
        behavior: "smooth"
      });
    };
    $[7] = cardHeight;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const scrollDown = t5;
  let t6;
  if ($[9] !== cardHeight) {
    t6 = () => {
      const viewport_1 = viewportRef.current;
      if (!viewport_1 || cardHeight === 0) {
        return;
      }
      viewport_1.scrollBy({
        top: -cardHeight,
        behavior: "smooth"
      });
    };
    $[9] = cardHeight;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const scrollUp = t6;
  let t7;
  if ($[11] !== canScrollDown || $[12] !== canScrollUp || $[13] !== cardHeight || $[14] !== scrollDown || $[15] !== scrollUp) {
    t7 = {
      scrollAreaRef,
      firstCardRef,
      canScrollUp,
      canScrollDown,
      cardHeight,
      scrollUp,
      scrollDown
    };
    $[11] = canScrollDown;
    $[12] = canScrollUp;
    $[13] = cardHeight;
    $[14] = scrollDown;
    $[15] = scrollUp;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}